@if (modalData != null) {
  <pgh-modal-window size="md">
    <div modal-body>
      <div class="d-flex align-items-end mb-4">
        <div class="subheader-semi-l text-center w-100">
          <adp-label [labelKey]="modalData.title"></adp-label>
        </div>
        <button mat-icon-button mat-dialog-close aria-label="Close" >
          <mat-icon class="close-icon-gray">close</mat-icon>
        </button>
      </div>
      <div>
        <adp-label [context]="modalData.model" [labelKey]="modalData.desc"></adp-label>
      </div>
    </div>
  </pgh-modal-window>
}
